<template>
  <v-dialog
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-model="isOpen"
    content-class="map-partner-mobile-booking noPartner"
    :persistent="true"
    no-click-animation
  >
    <template v-if="store">
      <!-- loading modal -->
      <v-dialog v-model="requesting" content-class="v-custom-pro">
        <v-progress-circular
          :size="100"
          :width="9"
          color="white"
          indeterminate
        ></v-progress-circular>
      </v-dialog>
      <div class="map-card-body">
        <div class="map-card-header">
          <div v-if="step == 1" class="no-service">
            <div class="service-item">
              <img
                src="../../assets/images/checkmark-icon-green.webp"
                alt="Häkchen-Symbol"
              />
              <p>Antwort innerhalb von 24 Stunden</p>
            </div>
            <div class="service-item">
              <img
                src="../../assets/images/checkmark-icon-green.webp"
                alt="Häkchen-Symbol"
              />
              <p>Persönliche Beratung</p>
            </div>
            <div class="service-item">
              <img
                src="../../assets/images/checkmark-icon-green.webp"
                alt="Häkchen-Symbol"
              />
              <p>Kostenloser Service</p>
            </div>
          </div>
          <div class="card-header-wrapper">
            <div class="card-header-body">
              <div class="header-body">
                <div class="header-title">
                  <div class="store-name">{{ store.storeName }}</div>
                  <div class="store-street">{{ store.address.street }}</div>
                  <div class="store-zip">
                    {{ store.address.zip }} {{ store.address.city }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="step == 1" class="card-summary-wrapper">
          <div class="no-title-body">
            <p class="no-title">Senden Sie jetzt eine unverbindliche Anfrage</p>
            <p class="no-sub-title">
              So erhalten Sie mit kompetenter Unterstützung auf dem schnellsten
              Weg Ihre Hilfsmittel
            </p>
          </div>
          <div class="book-form">
            <div class="form-header ext">
              <div class="book-title ext-3">
                <p>Ihre Anfrage</p>
              </div>
              <div class="summary-item ext-ml-0">
                <img
                  src="../../assets/images/Saved-products-icon.webp"
                  class="product"
                  alt="Symbol für gespeicherte Produkte"
                />
                <p v-if="data.products.length == 1">
                  {{ data.products[0].userSuggestion }}
                </p>
                <p v-else-if="data.products.length == 2">
                  {{ data.products[0].userSuggestion }},
                  {{ data.products[1].userSuggestion }}
                </p>
                <p v-else>{{ data.products.length }} Hilfsmittel</p>
              </div>
              <div
                v-if="JSON.stringify(data.insurance) != '{}'"
                class="summary-item ext-ml-0"
              >
                <img
                  src="../../assets/images/insurance-checkmark-icon-black.webp"
                  alt="Häkchen-Symbol"
                />
                <p>{{ data.insurance.krankenkasse }}</p>
              </div>
              <div class="summary-item ext-ml-0">
                <img
                  src="../../assets/images/location-icon.webp"
                  class="location"
                  alt="Standort-Symbol"
                />
                <p>{{ data.address.userSuggestion }}</p>
              </div>
            </div>
            <div class="form-body">
              <div class="book-body">
                <div class="book-body-wrap">
                  <div class="book-info">Kontaktdaten</div>
                  <div class="subform-element">
                    <v-text-field
                      v-model="firstName"
                      label="Vorname *"
                      class="custom-form-input"
                      height="46px"
                      :rules="rules.name"
                      outlined
                      dense
                    ></v-text-field>
                  </div>
                  <div class="subform-element">
                    <v-text-field
                      v-model="lastName"
                      label="Nachname *"
                      class="custom-form-input"
                      height="46px"
                      :rules="rules.name"
                      outlined
                      dense
                    ></v-text-field>
                  </div>
                  <div class="subform-element">
                    <v-text-field
                      v-model="email"
                      label="E-Mail *"
                      class="custom-form-input"
                      height="46px"
                      :rules="rules.email"
                      outlined
                      dense
                    ></v-text-field>
                  </div>
                  <div class="subform-element">
                    <v-text-field
                      v-model="phoneNumber"
                      label="Telefonnummer *"
                      class="custom-form-input"
                      height="46px"
                      :rules="rules.telephone"
                      outlined
                      dense
                      type="tel"
                    ></v-text-field>
                  </div>
                  <!-- <div class="book-info-2">Kassenübernahme</div> -->
                  <div class="prescription-radio">
                    Haben Sie bereits ein Rezept für Ihre gewählten Hilfsmittel?
                    *
                    <RadioButtonGroupRect
                      :data="prescriptionRadio"
                      @selectRadio="selectRadio"
                    />
                  </div>
                  <div class="book-msg">
                    <label>Ihre Nachricht an das Sanitätshaus (optional)</label>
                    <v-textarea
                      v-model="message"
                      label=""
                      height="140px"
                      single-line
                      outlined
                      dense
                    ></v-textarea>
                  </div>
                  <div class="book-term">
                    <v-checkbox v-model="checkTerm"></v-checkbox>
                    <p>
                      Ich stimme den
                      <a
                        href="https://www.anni.care/datenschutz/"
                        target="_blank"
                        class="jump-next"
                        >Datenschutzbestimmungen</a
                      >
                      zu und bin mit der Weitergabe meiner Daten an den Anbieter
                      einverstanden.
                    </p>
                  </div>
                  <button
                    v-if="passed"
                    class="g-blue-btn btn-absol w-100 he-43x mt-10x"
                    @click="sendRequest()"
                  >
                    Anfrage senden
                  </button>
                  <button
                    v-else
                    class="g-disabled-btn btn-absol w-100 he-43x mt-10x"
                  >
                    Anfrage senden
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="step == 2" class="prescription-final">
          <div class="p-result-body">
            <img
              src="../../assets/images/Prescription-sent-icon.webp"
              alt="Symbol „Rezept gesendet“"
            />
            <p class="f-title">Ihre Anfrage wurde erfolgreich gesendet</p>
            <p class="f-sub">
              Sie erhalten innerhalb von 24 Stunden eine Rückmeldung.
            </p>
          </div>
          <div class="btn-wrapper">
            <a href="https://anni.care/" target="_blank">
              <button class="to-home-btn" @click="back()">
                Zur Startseite
              </button>
            </a>
          </div>
        </div>
        <div v-if="step == 3" class="prescription-final">
          <div class="p-result-error">
            <p class="error-msg bold center">
              {{ UI_CONSTANTS.requestErrTitle }}
            </p>
            <p class="error-s-msg">{{ UI_CONSTANTS.requestErrMsg }}</p>
            <p class="error-s-msg bold center">
              {{ UI_CONSTANTS.requestNumber }}
            </p>
          </div>
          <div class="btn-wrapper">
            <a href="https://anni.care/" target="_blank">
              <button class="to-home-btn">Zur Startseite</button>
            </a>
          </div>
        </div>
      </div>
    </template>
  </v-dialog>
</template>
<script>
import {
  isValidMail,
  isValidTel,
  isValidName,
} from "../../services/ValidationService";
import { createNewOrder } from "../../services/MainService";
import UI_CONSTANTS from "../../../uiConstants";
import RadioButtonGroupRect from "../RadioButtons/RadioButtonGroupRect.vue";
import { mapActions } from "vuex";
export default {
  components: {
    RadioButtonGroupRect,
  },
  props: {
    isOpen: Boolean,
    store: Object,
    data: Object,
  },
  data() {
    return {
      step: 1,
      rules: {
        email: [(input) => isValidMail(input) || UI_CONSTANTS.wrongEmail],
        name: [(input) => isValidName(input) || UI_CONSTANTS.wrongName],
        telephone: [
          (input) => isValidTel(input) || UI_CONSTANTS.wrongTelephone,
        ],
      },
      isSuccess: false, // false
      passed: false,
      prescriptionRadio: "default",
      checkTerm: false,
      firstName: null,
      lastName: null,
      email: null,
      phoneNumber: null,
      message: null,
      requesting: false,
      UI_CONSTANTS: UI_CONSTANTS,
    };
  },
  methods: {
    ...mapActions(["recordInteraction"]),
    back() {
      this.formatData();
      this.step = 1;
      this.$emit("closeNoPtRe", false);
      // emit the mobile header data
      let mobileHeaderData;
      mobileHeaderData = {
        storeType: "nopartner",
        isOpened: false,
      };
      this.$root.$emit("mobile-checkout", mobileHeaderData);
    },
    selectRadio(e) {
      this.prescriptionRadio = e;
    },
    async sendRequest() {
      this.requesting = true;
      let data = {
        customerDetails: {
          firstname: "",
          lastname: "",
          telephone: "",
          mail: "",
          city: "",
        },
        orderDetails: {
          products: [],
          insurance: "",
          message: "",
          prescriptionPresent: false,
          selectedProvider: {
            dataSrc: "",
            storeID: "",
          },
        },
      };
      data.customerDetails.firstname = this.firstName;
      data.customerDetails.lastname = this.lastName;
      data.customerDetails.mail = this.email;
      data.customerDetails.phone1 = this.phoneNumber;
      data.customerDetails.city = this.data.address.userSuggestion;
      data.orderDetails.message = this.message ? this.message : "";
      data.orderDetails.prescriptionPresent =
        this.prescriptionRadio == "yes" ? true : false;
      data.orderDetails.products = this.data.products.map((item) => item.id);
      data.orderDetails.insurance =
        JSON.stringify(this.data.insurance) == "{}"
          ? undefined
          : this.data.insurance.insuranceID.toString();
      data.orderDetails.selectedProvider.dataSrc = this.store.dataSrc;
      data.orderDetails.selectedProvider.storeID =
        this.store.storeID.toString();
      data.orderDetails.selectedProvider.chainID = "n/a";
      let result = await createNewOrder(data);
      this.isSuccess = result.success;
      if (this.isSuccess) {
        this.step = 2;
      } else {
        this.step = 3;
      }
      this.nextScrollTop0();
      // emit the mobile header data
      let mobileHeaderData;
      mobileHeaderData = {
        storeType: "nopartner",
        step: 1,
        title: "Anfrage gesendet",
        lastStep: true,
        isOpened: true,
      };
      this.$root.$emit("mobile-checkout", mobileHeaderData);

      this.requesting = false;
      this.recordInteraction({
        eventType: "newInquiryPlaced",
        eventData: {
          listedPartner: false,
          typeOfInquiry: "writtenInquiry",
        },
      });
    },
    formatData() {
      this.step = 1;
      this.firstName = null;
      this.lastName = null;
      this.email = null;
      this.phoneNumber = null;
      this.message = null;
      this.checkTerm = false;
      this.passed = false;
      this.isSuccess = false;
      this.prescriptionRadio = "yes";
    },
    nextScrollTop0() {
      document.querySelector(".map-card-body").scrollTop = "0px";
    },
  },
  mounted() {
    this.$root.$on("mobile-checkout-back", async (data) => {
      if (data.storeType == "nopartner") {
        this.back();
      }
    });
  },
  watch: {
    firstName(value) {
      if (
        isValidName(value) &&
        isValidName(this.lastName) &&
        isValidMail(this.email) &&
        isValidTel(this.phoneNumber) &&
        this.checkTerm &&
        this.prescriptionRadio != "default"
      ) {
        this.passed = true;
      } else {
        this.passed = false;
      }
    },
    lastName(value) {
      if (
        isValidName(this.firstName) &&
        isValidName(value) &&
        isValidMail(this.email) &&
        isValidTel(this.phoneNumber) &&
        this.checkTerm &&
        this.prescriptionRadio != "default"
      ) {
        this.passed = true;
      } else {
        this.passed = false;
      }
    },
    email(value) {
      if (
        isValidName(this.firstName) &&
        isValidName(this.lastName) &&
        isValidMail(value) &&
        isValidTel(this.phoneNumber) &&
        this.checkTerm &&
        this.prescriptionRadio != "default"
      ) {
        this.passed = true;
      } else {
        this.passed = false;
      }
    },
    phoneNumber(value) {
      if (
        isValidName(this.firstName) &&
        isValidName(this.lastName) &&
        isValidMail(this.email) &&
        isValidTel(value) &&
        this.checkTerm &&
        this.prescriptionRadio != "default"
      ) {
        this.passed = true;
      } else {
        this.passed = false;
      }
    },
    checkTerm(value) {
      if (
        isValidName(this.firstName) &&
        isValidName(this.lastName) &&
        isValidMail(this.email) &&
        isValidTel(this.phoneNumber) &&
        value &&
        this.prescriptionRadio != "default"
      ) {
        this.passed = true;
      } else {
        this.passed = false;
      }
    },
    prescriptionRadio(value) {
      if (
        isValidName(this.firstName) &&
        isValidName(this.lastName) &&
        isValidMail(this.email) &&
        isValidTel(this.phoneNumber) &&
        this.checkTerm &&
        value != "default"
      ) {
        this.passed = true;
      } else {
        this.passed = false;
      }
    },
  },
};
</script>
